import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Loader } from 'packages/eid-ui';

const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    prop !== 'rootStylesProp' && prop !== 'color',
})(({ theme, rootStylesProp, color }) => ({
  textTransform: 'capitalize !important',
  fontSize: '16px',
  color: '#fff',
  backgroundColor: color || theme.palette.primary.main,
  boxShadow: 'none',
  minWidth: 'max-content',
  lineHeight: 1,
  position: 'relative',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: color || theme.palette.primary.main,
    '&::before': {
      borderRadius: 'inherit',
      content: '""',
      position: 'absolute',
      height: '100%',
      width: '100%',
      opacity: '0.17',
      backgroundColor: '#000',
      left: 0,
      top: 0,
    },
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: color || theme.palette.primary.main,
    opacity: 0.7,
  },
  '&:focus': {
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    color: '#fff !important',
    border: 'unset !important',
  },
  '& > *': {
    zIndex: 1,
  },
  ...rootStylesProp,
}));

const GenericButton = (props) => {
  const {
    loading,
    color,
    disabled,
    onClick,
    children,
    rootStylesProp,
    ...rest
  } = props;

  return (
    <StyledButton
      disabled={disabled}
      variant="contained"
      onClick={onClick}
      rootStylesProp={rootStylesProp}
      color={color}
      {...rest}
    >
      {loading ? <Loader color="#ffffff" /> : children}
    </StyledButton>
  );
};

export default GenericButton;